export default __webpack_public_path__ + "static/media/CirclePlus.37dafbec.svg";